module.exports = __webpack_public_path__ + "img/iana.c70c3a0d.png";